import PropTypes from 'prop-types';
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';

const AuthChecker = ({ operation, children }) => {
  const { authPolicies, user } = useAuthorizationContext();
  const isAuthorized = operation.some(ai => user.track_your_vehicle_functions.includes(ai))
  return children(isAuthorized);
};

AuthChecker.propTypes = {
  children: PropTypes.func.isRequired,
};

export default AuthChecker;
